import { Preloader } from 'mmfintech-portal-commons'

export const CustomPreloader = () => <Preloader color='#ef4444' />
